/**
 * Client-side CSV export helpers. Several INTERNAL ops surfaces hand their visible rows to finance as a file
 * because the runtime exposes no export endpoint; they all need the same two primitives, so the quoting rule
 * and the BOM live here instead of being re-implemented per module.
 */

/** RFC 4180 quoting: only cells containing a quote, comma or newline get wrapped, with `"` doubled. */
export function escapeCsvCell(value: string | null | undefined): string {
  const cell = value ?? "";
  return /["\n,]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell;
}

/**
 * Trigger a browser download of the given CSV content. The leading BOM is what makes Excel read the file as
 * UTF-8 — without it, accented organization names arrive mojibake.
 */
export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob([`﻿${content}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
